import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { MenusComponent } from './menus/menus.component';
import { CompaniesComponent } from './companies/companies.component';
import { CompanyComponent } from './company/company.component';
import { UsersComponent } from './users/users.component';
import { UserComponent } from './user/user.component';
import { WorkersComponent } from './workers/workers.component';
import { WorkerComponent } from './worker/worker.component';
import { ZonesComponent } from './zones/zones.component';
import { ZoneComponent } from './zone/zone.component';
import { ProjectsComponent } from './projects/projects.component';
import { ProjectComponent } from './project/project.component';
import { DevicesComponent } from './devices/devices.component';
import { DeviceComponent } from './device/device.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { FaqComponent } from './faq/faq.component';
import { DialogComponent } from './dialog/dialog.component';
import { HomeComponent } from './home/home.component';
import { ImportComponent } from './import/import.component';
import { DeviceScannerComponent } from './device-scanner/device-scanner.component';
import { ReportComponent } from './report/report.component';
import { AlarmConfigurationComponent, AlarmConfigurationFunctionMode } from './alarm-configuration/alarm-configuration.component';
import { QrDeviceRedirectComponent } from './qr-device/qr-device-redirect.component';


const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'menus', component: MenusComponent },

  { path: 'home', component: MenusComponent,
    children: [
      { path: '', component: HomeComponent },
    ]
  },

  { path: 'companies', component: MenusComponent,
    children: [
      { path: '', component: CompaniesComponent },
    ]
  },

  { path: 'company', component: MenusComponent,
    children: [
      { path: '', component: CompanyComponent },
      { path: 'company/:id', component: CompanyComponent },
      { path: 'company/dialog', component: DialogComponent },
    ]
  },

  { path: 'users', component: MenusComponent,
    children: [
      { path: '', component: UsersComponent },
    ]
  },

  { path: 'user', component: MenusComponent,
    children: [
      { path: '', component: UserComponent },
      { path: 'user/:id', component: UserComponent },
      { path: 'user/dialog', component: DialogComponent },
    ]
  },

  { path: 'workers', component: MenusComponent,
    children: [
      { path: '', component: WorkersComponent },
    ]
  },

  { path: 'worker', component: MenusComponent,
    children: [
      { path: '', component: WorkerComponent },
      { path: 'worker/:id', component: WorkerComponent },
      { path: 'worker/dialog', component: DialogComponent },
    ]
  },

  { path: 'zones', component: MenusComponent,
    children: [
      { path: '', component: ZonesComponent },
    ]
  },

  { path: 'faq', component: MenusComponent,
    children: [
      { path: '', component: FaqComponent },
    ]
  },

  { path: 'zone', component: MenusComponent,
    children: [
      { path: '', component: ZoneComponent },
      { path: 'zone/:id', component: ZoneComponent },
      { path: 'zone/dialog', component: DialogComponent },
    ]
  },

  { path: 'projects', component: MenusComponent,
    children: [
      { path: '', component: ProjectsComponent },
    ]
  },

  { path: 'project', component: MenusComponent,
    children: [
      { path: '', component: ProjectComponent },
      { path: 'project/:id', component: ProjectComponent },
      { path: 'project/dialog', component: DialogComponent },
    ]
  },

  { path: 'devices', component: MenusComponent,
    children: [
      { path: '', component: DevicesComponent },
    ]
  },

  { path: 'alarmConfiguration', component: MenusComponent,
    children: [
      { path: '', component: AlarmConfigurationComponent, data: { parent_type: AlarmConfigurationFunctionMode.COMPANY } },
    ]
  },

  { path: 'device', component: MenusComponent,
    children: [
      { path: '', component: DeviceComponent },
      { path: 'device/:id', component: DeviceComponent },
      { path: 'device/dialog', component: DialogComponent },
    ]
  },

  { path: 'configuration', component: ConfigurationComponent,
    children: [
      { path: '', component: DeviceComponent },
      { path: 'configuration/:id', component: ConfigurationComponent },
      { path: 'configuration/dialog', component: DialogComponent },
    ]
  },
  { path: 'import', component: MenusComponent,
    children: [
      { path: '', component: ImportComponent },
    ]
  },
  { path: 'qrDevice', component: MenusComponent,
    children: [
      { path: '', component: QrDeviceRedirectComponent },
    ]
  },
  { path: 'report', component: MenusComponent,
    children: [
      { path: '', component: ReportComponent },
    ]
  },
  { path: 'billing', component: MenusComponent, loadChildren: () => import('./billing/billing.module').then(module => module.BillingModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes , { useHash: true } )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
